import flow from 'lodash/fp/flow'

import regex from './regex.validator'

export default ({ t }) => YupInstance => flow(
  regex({ t, text: 'invalid hour', regex: '/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/' })
)(YupInstance)

